// Minimal SkioBoxChildProducts component with integrated plan picker
import { LitElement, html, css } from "https://cdn.jsdelivr.net/gh/lit/dist@2/core/lit-core.min.js";

const boxChildStyles = css`
  :host {
    position: relative;
  }
  
  .skio-box-header,
  .skio-box-footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 1rem;
    padding: 0 1rem;
    max-width: 1220px;
    margin: 0 auto 1rem auto;
    flex-wrap: wrap;
  }

   .skio-box-footer {
     position: -webkit-sticky;
     position: sticky;
     bottom: 10px;
     left: 0;
     right: 0;
     background-color: #fff;
     padding: 1rem;
     border-top: 1px solid #eee;
     box-shadow: 0 2px 8px rgba(0,0,0,.15),0 2px 20px rgba(0,0,0,.15);
   }

  .skio-box-footer strong {
    font-weight: 700;
    font-size: 24.32px;
    line-height: 1.25;
  }
  
  .skio-frequency-label {
    font-weight: 500;
    color: #333;
  }
  
  .skio-frequency-dropdown {
    appearance: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    background-color: #fff;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' class='h-6 w-6' fill='none' viewBox='0 0 24 24' stroke='currentColor' stroke-width='2'%3E%3Cpath stroke-linecap='round' stroke-linejoin='round' d='M19 9l-7 7-7-7' /%3E%3C/svg%3E");
    background-repeat: no-repeat;
    background-position: right 10px top 50%;
    background-size: 16px;
    border: 1px solid #ccc;
    border-radius: 2px;
    padding: 8px 30px 8px 10px;
    font-size: 14px;
    color: #000;
    outline: none;
    font-family: inherit;
    cursor: pointer;
  }
  
  .skio-add-to-cart-btn {
    background-color: #f4db67;
    color: #000;
    border: none;
    border-radius: 4px;
    padding: 8px 16px;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    font-family: inherit;
  }
  
  .skio-add-to-cart-btn:hover {
    background-color: #f7e697;
  }
  
  .skio-add-to-cart-btn:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
  
  .skio-box-child-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
    gap: 1rem;
    margin: 2rem auto;
    z-index: 0;
    padding: 0 1rem;
    max-width: 1220px;
  }

  .skio-box-child-card {
    border: 1px solid #eee;
    border-radius: 8px;
    padding: 1rem;
    text-align: center;
    background: #fff;
    box-shadow: 0 2px 8px rgba(0,0,0,0.03);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    min-height: 200px;
  }
  .skio-box-child-card img {
    width: 120px;
    height: 120px;
    object-fit: cover;
    border-radius: 8px;
    margin-bottom: 10px;
  }
  
  .skio-box-child-card-title-container {
    margin-bottom: 10px;
    text-align: center;
  }
  
  .skio-box-child-card-title {
    font-size: 0.9rem;
    font-weight: 500;
    margin-bottom: 5px;
    line-height: 1.3;
  }
  
  .skio-box-child-card-variant-title {
    font-size: 0.8rem;
    color: #666;
  }
  
  .skio-box-child-card-price {
    margin-bottom: 10px;
    font-weight: 500;
  }
  
  .skio-box-child-card-price s {
    color: #999;
    margin-right: 5px;
  }
  
  .skio-box-child-card label {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 10px;
  }

  .skio-box-child-card button,
  .skio-box-child-card input[type="number"] {
    width: 40px;
    height: 40px;
    border: 1px solid #eee;
    background: #f4db67;
    border-radius: 4px;
    cursor: pointer;
    font-size: 1.2rem;
    font-weight: 600;
    color: #222;
    text-align: center;
  }

  .skio-box-child-card button {
    height: 40px;
    width: 40px;
  }

  .skio-box-child-card button:first-of-type {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
    border-right: none;
  }

  .skio-box-child-card button:last-of-type {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    border-left: none;
  }

  .skio-box-child-card input[type="number"] {
    border-radius: 0;
    border-left: none;
    border-right: none;
    height: 40px;
    padding: 0;
    background: #fff;
  }

  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  
`;

export class SkioBoxChildProducts extends LitElement {
  static styles = boxChildStyles;
  static properties = {
    product: { type: Object },
    productHandle: { type: String },
    variantId: { type: String },
    childProducts: { state: true },
    loading: { state: true },
    error: { state: true },
    selectedVariants: { state: true },
    selectedVariant: { type: Object },
    maxQuantity: { state: true },
    options: { type: Object },
    // Plan picker properties
    availableSellingPlanGroups: { state: true },
    selectedSellingPlanGroup: { type: Object },
    selectedSellingPlan: { type: Object },
    moneyFormat: { type: String },
    // Variant selection for products with multiple variants
    selectedProductVariants: { state: true },
    // Dynamic box data from API
    dynamicBoxData: { state: true },
  };

  constructor() {
    super();
    this.product = null;
    this.productHandle = '';
    this.variantId = '';
    this.childProducts = [];
    this.loading = false;
    this.error = '';
    this.selectedVariants = {};
    this.selectedVariant = null;
    this.maxQuantity = 0;
    // Plan picker initialization
    this.availableSellingPlanGroups = [];
    this.selectedSellingPlanGroup = null;
    this.selectedSellingPlan = null;
    this.moneyFormat = '{{amount}}';
    this.selectedProductVariants = {};
    this.dynamicBoxData = null;
  }

  connectedCallback() {
    super.connectedCallback();
    this._initSelectedVariantFromAttribute();
    this._initProduct().then(() => {
      this._fetchChildProducts();
      this._setupVariantListeners();
      this._setupFormIntegration();
    });
  }

  disconnectedCallback() {
    super.disconnectedCallback();
  }

  _initSelectedVariantFromAttribute() {
    // Check if selectedVariant was passed as an attribute from Liquid template
    const selectedVariantAttr = this.getAttribute('selectedVariant');
    if (selectedVariantAttr) {
      try {
        const variant = JSON.parse(selectedVariantAttr);
        if (variant && variant.id) {
          this.selectedVariant = variant;
          this.variantId = variant.id;
        }
      } catch (e) {
        console.warn('Failed to parse selectedVariant attribute:', e);
      }
    }
  }

  async _initProduct() {
    
    if (this.product) {
      // If product is already provided
      this.variantId = this.product.variants?.[0]?.id || '';
      if (this.product.variants?.[0]) {
        this.selectedVariant = this.product.variants[0];
      }
    } else if (this.productHandle) {
      // Fetch product JSON from Shopify
      const url = `/products/${this.productHandle}.js`;
      try {
        const res = await fetch(url);
        if (!res.ok) {
          throw new Error(`Failed to fetch product: ${res.status} ${res.statusText}`);
        }
        this.product = await res.json();
        this.variantId = this.product.variants?.[0]?.id || '';
        // Initialize selectedVariant to trigger maxQuantity calculation
        if (this.product.variants?.[0]) {
          this.selectedVariant = this.product.variants[0];
        }
      } catch (e) {
        console.error('Failed to fetch product:', e);
        this.error = e.message;
      }
    } else {
      console.warn('No product or productHandle provided');
    }
    
    // Try to get current variant from form if available
    this._tryGetCurrentVariantFromForm();
  }

  async _fetchChildProducts() {
    if (!this.product || !this.product.id) {
      console.warn('No product available to fetch child products');
      return;
    }
    this.loading = true;
    this.error = '';
    try {
      const res = await fetch('https://api.skio.com/storefront-http/get-dynamic-box', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ productPlatformId: this.product.id }),
      });
      const data = await res.json();
      console.log('Child products fetched:', data);
      if (!res.ok || !data.DynamicBox.selectableProductVariants) throw new Error('Failed to fetch child products');
      
      // Store the complete dynamic box data
      this.dynamicBoxData = data.DynamicBox;
      this.childProducts = data.DynamicBox.selectableProductVariants || []; 
      
      // Initialize selected variants for each product (default to first variant)
      this.selectedProductVariants = {};
      this.childProducts.forEach(product => {
        if (product.productVariants && product.productVariants.length > 0) {
          this.selectedProductVariants[product.productPlatformId] = product.productVariants[0];
        }
      });
      
      // Setup plan picker after dynamic box data is loaded
      this._setupPlanPicker();
      
    } catch (e) {
      this.error = e.message;
      this.childProducts = [];
    } finally {
      this.loading = false;
    }
  }

  updated(changed) {
    if (changed.has('selectedVariant') && this.selectedVariant) {
      this._setupPlanPicker();
    }
  }

  _onQuantityChange(e, product) {
    const value = parseInt(e.target.value, 10);
    const selectedVariant = this.selectedProductVariants[product.productPlatformId];
    const variantId = selectedVariant?.platformId;
    
    console.log('_onQuantityChange called:', { value, selectedVariant, variantId, product: product.productTitle });
    
    if (!variantId) {
      console.log('No variantId, returning');
      return;
    }
    
    if (value > 0) {
      this.selectedVariants = { ...this.selectedVariants, [variantId]: value };
      console.log('Added to selectedVariants:', variantId, value);
    } else {
      // Remove if value is 0 or less
      const updated = { ...this.selectedVariants };
      delete updated[variantId];
      this.selectedVariants = updated;
      console.log('Removed from selectedVariants:', variantId);
    }
    
    console.log('Updated selectedVariants:', this.selectedVariants);
    this._injectHiddenInputs();
  }

  _changeQuantityBy(product, delta) {
    const selectedVariant = this.selectedProductVariants[product.productPlatformId];
    const variantId = selectedVariant?.platformId;
    
    console.log('_changeQuantityBy called:', { delta, selectedVariant, variantId, product: product.productTitle });
    
    if (!variantId) {
      console.log('No variantId, returning');
      return;
    }
    
    const current = this.selectedVariants[variantId] || 0;
    let next = current + delta;
    if (delta > 0 && current === 0) {
      next = 1; // If incrementing from 0, set to 1
    }
    if (next < 0) next = 0;
    // Prevent exceeding max
    const totalSelected = Object.values(this.selectedVariants).reduce((sum, q) => sum + q, 0) - current + next;
    if (this.maxQuantity && totalSelected > this.maxQuantity) {
      next = current; // Don't allow increment if it would exceed max
    }
    
    console.log('Quantity change:', { current, next, delta, totalSelected, maxQuantity: this.maxQuantity });
    
    const fakeEvent = { target: { value: next } };
    this._onQuantityChange(fakeEvent, product);
    this._injectHiddenInputs();
  }

  _onProductVariantChange(e, product) {
    const variantId = e.target.value;
    const selectedVariant = product.productVariants.find(v => v.platformId === variantId);
    if (selectedVariant) {
      this.selectedProductVariants = {
        ...this.selectedProductVariants,
        [product.productPlatformId]: selectedVariant
      };
      
      // Update quantity if this variant was previously selected
      const oldQuantity = this.selectedVariants[selectedVariant.platformId] || 0;
      if (oldQuantity > 0) {
        this.selectedVariants = { ...this.selectedVariants, [selectedVariant.platformId]: oldQuantity };
      }
      
      this._injectHiddenInputs();
    }
  }

  _setupVariantListeners() {
    // Try to find the product form and variant input
    let form = this.closest('form') || document.querySelector('form[action*="/cart/add"]');
    let variantInput = form ? form.querySelector('[name="id"]') : document.querySelector('[name="id"]');
    if (variantInput && this.product && Array.isArray(this.product.variants)) {
      variantInput.addEventListener('change', e => {
        const variant = this.product.variants.find(v => v.id == e.target.value);
        if (variant) {
          this.selectedVariant = variant;
        }
      });
    }
    // Listen for global variantChanged event (Skio convention)
    document.addEventListener('variantChanged', e => {
      if (!this.product || !Array.isArray(this.product.variants)) return;
      let variantId = e.detail.variantId;
      let variant = this.product.variants.find(x => x.id == variantId);
      if (variant) {
        this.selectedVariant = variant;
      }
    });
  }

  _tryGetCurrentVariantFromForm() {
    // Try to get the currently selected variant from the form
    const form = this.findProductForm();
    if (form && this.product && Array.isArray(this.product.variants)) {
      const variantId = this.getVariantId(form);
      if (variantId) {
        const variant = this.product.variants.find(v => v.id == variantId);
        if (variant) {
          this.selectedVariant = variant;
          this.variantId = variantId;
        }
      }
    }
  }

  _setupFormIntegration() {
    // Always use the main product form for theme-agnostic support
    this._form = document.querySelector('form[action*="/cart/add"]');
  }

  findProductForm() {
    // First try finding form through parent elements
    const formFromParent = this.findFormThroughParents();
    if (formFromParent) return formFromParent;
    // If no form found through parents, look for any valid product forms on page
    const allProductForms = this.getAllProductForms();
    return allProductForms[0] || null;
  }

  findFormThroughParents() {
    let currentElement = this;
    let depth = 0;
    const maxDepth = 5;
    while (currentElement.parentElement && depth < maxDepth) {
      const forms = Array.from(currentElement.querySelectorAll('form'));
      const validForm = forms.find(form => this.isValidProductForm(form));
      if (validForm) return validForm;
      currentElement = currentElement.parentElement;
      depth++;
    }
    return null;
  }

  getAllProductForms() {
    return Array.from(document.forms).filter(form => {
      const hasVariantId = this.getVariantId(form);
      return this.isValidProductForm(form) && hasVariantId;
    });
  }

  isValidProductForm(form) {
    const hasCartAction = form.getAttribute('action')?.includes('/cart/add');
    const hasSubmitButton = !!form.querySelector('button, [type="submit"]');
    return hasCartAction && hasSubmitButton;
  }

  getVariantId(form) {
    // Try getting ID from FormData first
    const formData = new FormData(form);
    const idFromFormData = formData.get('id');
    if (idFromFormData) return Number(idFromFormData);
    // Fallback to finding input element
    const idInput = form.querySelector('[name="id"]');
    return idInput ? Number(idInput.value) : null;
  }
 
  _injectHiddenInputs() {
    const form = this.findProductForm();
    if (!form) return;
    // Remove any previous hidden inputs for child variants
    Array.from(form.querySelectorAll('input[data-skio-child-variant]')).forEach(input => input.remove());
    // Add hidden inputs for each selected child variant
    for (const [variantId, qty] of Object.entries(this.selectedVariants)) {
      if (qty > 0) {
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = `properties[_pv${variantId}]`;
        input.value = qty;
        input.setAttribute('data-skio-child-variant', 'true');
        form.appendChild(input);
        
        // Add hidden input for product title
        const child = this.childProducts.find(c => 
          c.productVariants.some(v => v.platformId === variantId)
        );
        if (child) {
          const titleInput = document.createElement('input');
          titleInput.type = 'hidden';
          titleInput.name = `properties[${child.productTitle}]`;
          titleInput.value = qty;
          titleInput.setAttribute('data-skio-child-variant', 'true');
          form.appendChild(titleInput);
        }
      }
    }
    this._updateAddToCartButtonState();
  }

  _updateAddToCartButtonState() {
    const form = this.findProductForm();
    if (!form) return;
    const addToCartBtn = form.querySelector('button[type="submit"], [type="submit"]');
    if (!addToCartBtn) return;
    
    // If preset_box is true, always enable the add to cart button
    if (this.options?.preset_box) {
      addToCartBtn.disabled = false;
      return;
    }
    
    const totalSelected = Object.values(this.selectedVariants).reduce((sum, q) => sum + q, 0);
    const shouldEnable = this.maxQuantity && totalSelected === this.maxQuantity;
    addToCartBtn.disabled = !shouldEnable;
    
  }

  // Plan picker methods
  _setupPlanPicker() {
    // Use dynamic box selling plan data if available
    if (this.dynamicBoxData && this.dynamicBoxData.sellingPlanGroup && Object.keys(this.dynamicBoxData.sellingPlanGroup).length > 0) {
      this._setupFromDynamicBoxSellingPlans();
    } else if (this.product && this.selectedVariant && this.product.selling_plan_groups) {
      this._setupFromProductSellingPlans();
    } else {
      console.log('No selling plans available');
    }
  }

  _setupFromDynamicBoxSellingPlans() {
    // Convert dynamic box selling plan data to our format
    const sellingPlanEntries = Object.entries(this.dynamicBoxData.sellingPlanGroup);
    
    // Sort selling plans by position
    const sortedSellingPlanEntries = sellingPlanEntries.sort((a, b) => {
      const posA = a[1].position || 0;
      const posB = b[1].position || 0;
      return posA - posB;
    });
    
    // Create selling plans array with one-time purchase option first
    const sellingPlans = [
      {
        id: 'one_time',
        name: 'Solo una volta',
        position: -1, // Ensure it's first
        price_adjustments: [{
          value_type: 'percentage',
          value: 0,
          position: 1
        }]
      },
      ...sortedSellingPlanEntries.map(([planId, planData]) => ({
        id: planId,
        name: planData.title,
        position: planData.position,
        price_adjustments: [{
          value_type: planData.priceAdjustmentType?.toLowerCase(),
          value: planData.priceAdjustmentAmount,
          position: 1
        }]
      }))
    ];
    
    this.availableSellingPlanGroups = [{
      id: 'dynamic_box_group',
      name: 'Purchase Options',
      app_id: 'SKIO',
      selling_plans: sellingPlans
    }];
    
      // Set default to "Ogni 4 settimane - 10% di sconto" (or first available plan if not found)
      if (this.availableSellingPlanGroups[0]?.selling_plans?.length) {
        this.selectedSellingPlanGroup = this.availableSellingPlanGroups[0];
        
        // Find "Ogni 4 settimane" plan
        const fourWeekPlan = this.availableSellingPlanGroups[0].selling_plans.find(
          plan => plan.name.includes('Ogni 4 settimane')
        );
        
        // Default to "Ogni 4 settimane" if found, otherwise first plan
        this.selectedSellingPlan = fourWeekPlan || this.availableSellingPlanGroups[0].selling_plans[0];
        this._updateFormWithSellingPlan();
      }
  }

  _setupFromProductSellingPlans() {
    // Filter selling plan groups to only show dynamic box subscription plans
    const filteredSellingPlanGroups = this.product.selling_plan_groups.filter(
      selling_plan_group =>
        selling_plan_group.app_id === 'SKIO' && 
        selling_plan_group.name.toLowerCase().includes('dynamic box subscription') &&
        !selling_plan_group.name.toLowerCase().includes('hidden-') 
    );

    // Update availableSellingPlanGroups based on filtered groups and selectedVariant
    this.availableSellingPlanGroups = filteredSellingPlanGroups.filter(selling_plan_group =>
      selling_plan_group.selling_plans.some(selling_plan =>
        this.selectedVariant.selling_plan_allocations.some(selling_plan_allocation => 
          selling_plan_allocation.selling_plan_id === selling_plan.id
        )
      )
    );

    // Set default selected selling plan
    if (this.availableSellingPlanGroups?.length) {
      this.availableSellingPlanGroups.forEach(group => {
        const availableSellingPlans = this._getAvailableSellingPlans(group);
        group.selected_selling_plan = availableSellingPlans[0];
      });
      
      // Select the first group by default
      this.selectedSellingPlanGroup = this.availableSellingPlanGroups[0];
      this.selectedSellingPlan = this.selectedSellingPlanGroup?.selected_selling_plan;
      
      // Update the form with the default selling plan
      this._updateFormWithSellingPlan();
    }
  }

  _getAvailableSellingPlans(group) {
    // For dynamic box selling plans, return all plans since they apply to all variants
    if (group.id === 'dynamic_box_group') {
      return group.selling_plans;
    }
    
    // For product selling plans, filter based on variant allocations
    if (!this.selectedVariant || !this.selectedVariant.selling_plan_allocations) {
      return group.selling_plans;
    }
    
    return group.selling_plans.filter(selling_plan =>
      this.selectedVariant.selling_plan_allocations.some(selling_plan_allocation => 
        selling_plan_allocation.selling_plan_id === selling_plan.id
      )
    );
  }

  _onSellingPlanChange(e) {
    console.log('_onSellingPlanChange called with value:', e.target.value);
    const sellingPlanId = e.target.value;
    
    // Handle one-time purchase
    if (sellingPlanId === 'one_time') {
      this.selectedSellingPlan = null;
      console.log('Selected one-time purchase');
      this._updateFormWithSellingPlan();
      return;
    }
    
    const selectedGroup = this.availableSellingPlanGroups.find(group => 
      group.selling_plans.some(plan => plan.id == sellingPlanId)
    );
    const selectedSellingPlan = selectedGroup?.selling_plans.find(plan => plan.id == sellingPlanId);

    console.log('Found selected group and plan:', { selectedGroup, selectedSellingPlan });

    if (selectedGroup && selectedSellingPlan) {
      selectedGroup.selected_selling_plan = selectedSellingPlan;
      this.selectedSellingPlanGroup = selectedGroup;
      this.selectedSellingPlan = selectedSellingPlan;
      console.log('Updated to selling plan:', this.selectedSellingPlan);
      this._updateFormWithSellingPlan();
    }
  }

  _updateFormWithSellingPlan() {
    const form = this.findProductForm();
    if (!form) return;
    
    // Remove existing selling plan input
    const existingSellingPlanInput = form.querySelector('input[name="selling_plan"]');
    if (existingSellingPlanInput) {
      existingSellingPlanInput.remove();
    }
    
    // Add new selling plan input
    if (this.selectedSellingPlan) {
      const sellingPlanInput = document.createElement('input');
      sellingPlanInput.type = 'hidden';
      sellingPlanInput.name = 'selling_plan';
      sellingPlanInput.value = this.selectedSellingPlan.id;
      form.appendChild(sellingPlanInput);
    }
  }

  _addToCart() {
    console.log('_addToCart called');
    console.log('selectedVariants:', this.selectedVariants);
    console.log('selectedSellingPlan:', this.selectedSellingPlan);
    
    // Get the dynamic box data
    const dynamicBoxData = this._getDynamicBoxData();
    console.log('dynamicBoxData:', dynamicBoxData);
    if (!dynamicBoxData) {
      console.log('No dynamicBoxData, returning');
      return;
    }
    
    // Prepare items for cart
    const items = [];
    
    // Add each selected product variant to cart
    Object.entries(this.selectedVariants).forEach(([variantId, qty]) => {
      if (qty > 0) {
        // Extract numeric ID from GID format if needed
        let numericId = variantId;
        if (variantId.includes('gid://shopify/ProductVariant/')) {
          numericId = variantId.split('/').pop();
        }
        
        const item = {
          quantity: qty,
          id: numericId,
          properties: {
            _dynamicBoxIndex: 0,
            _dynamicBoxId: dynamicBoxData.boxId
          }
        };
        
        // Add selling plan as a direct property on the item (not nested in properties)
        if (this.selectedSellingPlan) {
          // Extract numeric ID from selling plan GID if needed
          let sellingPlanId = this.selectedSellingPlan.id;
          if (sellingPlanId.includes('gid://shopify/SellingPlan/')) {
            sellingPlanId = sellingPlanId.split('/').pop();
          }
          item.selling_plan = parseInt(sellingPlanId, 10);
        }
        
        console.log('Adding item to cart:', item);
        items.push(item);
      }
    });
    
    console.log('Items to add to cart:', items);
    
    if (items.length === 0) {
      console.log('No items selected, returning');
      return;
    }
    
    // Add to cart via AJAX
    console.log('Sending request to /cart/add.js');
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        items: items
      }),
    })
    .then(response => {
      if (!response.ok) {
        return response.json().then(err => {
          throw new Error(err.description || err.message || 'Failed to add to cart');
        });
      }
      return response.json();
    })
    .then(response => {
      // Dispatch custom event for cart update
      document.dispatchEvent(new CustomEvent('CartUpdated', {
        detail: response
      }));
      
      // Redirect to cart or show success message
      window.location.href = '/checkout';
    })
    .catch(error => {
      console.error('Error adding items to cart:', error);
    });
  }

  _getDynamicBoxData() {
    // Use the dynamic box data from the API response
    if (this.dynamicBoxData && this.dynamicBoxData.boxId) {
      return {
        boxId: this.dynamicBoxData.boxId,
        boxIndex: 0 // Default to 0 for first box
      };
    }
    
    // Fallback: try to extract from the product data or generate a default
    if (this.product && this.product.id) {
      return {
        boxId: `box_${this.product.id}`, // Generate a box ID based on product ID
        boxIndex: 0
      };
    }
    
    return null;
  }

  // Money formatting function (simplified version from plan picker)
  _formatMoney(price) {
    if (typeof price !== 'number') return '0,00 €';
    // Price values from the API are already in euros, not cents
    return price.toFixed(2).replace('.', ',') + ' €';
  }

  // Calculate total price of selected items
  _calculateTotal() {
    let total = 0;
    let compareAtTotal = 0;
    
    Object.entries(this.selectedVariants).forEach(([variantId, qty]) => {
      if (qty > 0) {
        // Find the product and variant
        for (const product of this.childProducts) {
          const variant = product.productVariants.find(v => v.platformId === variantId);
          if (variant) {
            total += variant.price * qty;
            if (variant.compareAtPrice) {
              compareAtTotal += variant.compareAtPrice * qty;
            }
            break;
          }
        }
      }
    });
    
    // Apply selling plan discount if applicable
    if (this.selectedSellingPlan && this.selectedSellingPlan.price_adjustments?.length > 0) {
      const adjustment = this.selectedSellingPlan.price_adjustments[0];
      if (adjustment.value_type === 'percentage') {
        total = total * (1 - (adjustment.value / 100));
      }
    }
    
    return { total, compareAtTotal };
  }

  render() {
    // If preset_box is true, don't show the UI
    if (this.options?.preset_box) {
      return html``;
    }
    
    if (!this.childProducts.length) {
      return html``;
    }
    
    if (this.loading) {
      return html`<div style="text-align:center;">Loading options...</div>`;
    }
    
    const totalSelected = Object.values(this.selectedVariants).reduce((sum, q) => sum + q, 0);
    const max = this.maxQuantity;
    const percent = max ? Math.min(100, Math.round((totalSelected / max) * 100)) : 0;

    return html`
      <div class="skio-box-header">
        <div style="width: 100%; flex-basis: 100%;">
        <h2>${this.product.title}</h2>
        </div>
        <div style="display: flex; gap: 5px; flex-direction: column;">
          <span class="skio-frequency-label">Frequenza</span>
          <select 
            class="skio-frequency-dropdown"
            @change="${this._onSellingPlanChange}"
            ?disabled="${!this.availableSellingPlanGroups?.length}"
          >
            ${this.availableSellingPlanGroups?.length ? 
              this.availableSellingPlanGroups.flatMap(group => 
                group.selling_plans.map(plan => {
                  const isSelected = plan.id === 'one_time' 
                    ? !this.selectedSellingPlan 
                    : this.selectedSellingPlan?.id === plan.id;
                  return html`<option value="${plan.id}" ?selected="${isSelected}">${plan.name}</option>`;
                })
              ) : 
              html`<option>Nessuna opzione disponibile</option>`
            }
          </select>
        </div>
        <button 
          class="skio-add-to-cart-btn"
          @click="${this._addToCart}"
          ?disabled="${totalSelected === 0 || (max && totalSelected !== max)}"
        >
          Aggiungi al carrello
        </button>
      </div>
      
      <div class="skio-box-child-grid">
        ${this.childProducts.map(product => {
          const selectedVariant = this.selectedProductVariants[product.productPlatformId];
          const variantId = selectedVariant?.platformId;
          const quantity = variantId ? (this.selectedVariants[variantId] || 0) : 0;
          const disableUp = max && totalSelected >= max;
          
          // Calculate price from selected variant
          let basePrice = selectedVariant?.price || 0;
          const compareAtPrice = selectedVariant?.compareAtPrice || null;
          
          // Apply subscription discount if a selling plan is selected
          let discountedPrice = basePrice;
          if (this.selectedSellingPlan && this.selectedSellingPlan.price_adjustments?.length > 0) {
            const adjustment = this.selectedSellingPlan.price_adjustments[0];
            if (adjustment.value_type === 'percentage') {
              discountedPrice = basePrice * (1 - (adjustment.value / 100));
            }
          }
          
          return html`
            <div class="skio-box-child-card">
              <img src="${product.productImageSrc}" alt="${product.productTitle}" />
              <div class="skio-box-child-card-title-container">
                <div class="skio-box-child-card-title">${product.productTitle}</div>
                ${product.productVariants.length > 1 ? html`
                  <select 
                    class="skio-product-variant-dropdown"
                    @change="${e => this._onProductVariantChange(e, product)}"
                    style="margin-top: 5px; width: 100%; padding: 4px; border: 1px solid #ccc; border-radius: 2px; font-size: 12px;"
                  >
                    ${product.productVariants.map(variant => 
                      html`<option value="${variant.platformId}" ?selected="${selectedVariant?.platformId === variant.platformId}">${variant.productVariantTitle}</option>`
                    )}
                  </select>
                ` : html`
                  ${selectedVariant?.productVariantTitle && !selectedVariant.productVariantTitle.includes('Default Title') ? 
                    html`<div class="skio-box-child-card-variant-title">${selectedVariant.productVariantTitle}</div>` : ''}
                `}
              </div>
              
              <div class="skio-box-child-card-price">
                ${this.selectedSellingPlan ? html`
                  <s>${this._formatMoney(basePrice)}</s>
                  <span>${this._formatMoney(discountedPrice)}</span>
                ` : html`
                  <span>${this._formatMoney(basePrice)}</span>
                `}
              </div>
              
              <div>
                <label>
                  <button type="button" @click="${() => this._changeQuantityBy(product, -1)}">-</button>
                  <input type="number" min="0" step="1" .value="${quantity}" @input="${e => this._onQuantityChange(e, product)}" @change="${e => this._onQuantityChange(e, product)}" />
                  <button type="button" @click="${() => this._changeQuantityBy(product, 1)}" ?disabled="${disableUp}">+</button>
                </label>
              </div>
            </div>
          `;
        })}
      </div>
      
       <div class="skio-box-footer" style="margin-top: 20px;">
          <div>
            <strong>Scegliete quanti ne volete</strong>
            <div style="color: #333; font-size: 14px; ${totalSelected > 0 ? ``:`display: none;`}">
              ${totalSelected} selezionato: 
              ${(() => {
                const { total, compareAtTotal } = this._calculateTotal();
                return html`
                  <span>${this._formatMoney(total)}</span>
                `;
              })()}
            </div>
          </div>
        <button 
          class="skio-add-to-cart-btn"
          @click="${this._addToCart}"
          ?disabled="${totalSelected === 0 || (max && totalSelected !== max)}"
        >
          Aggiungi al carrello
        </button>
      </div>
    `;
  }
}

customElements.define('skio-dynamic-box', SkioBoxChildProducts);